"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var idGenerator_1 = require("spry-react/utils/idGenerator");
require("./checkboxField.less");
var useFocusRef_1 = require("spry-react/utils/hooks/useFocusRef");
var classNames = require("classnames");
function CheckboxField(props) {
    var _a;
    var generatedId = React.useRef(idGenerator_1.GenerateId());
    var id = (_a = props.id, (_a !== null && _a !== void 0 ? _a : generatedId.current));
    var inputHtmlRef = useFocusRef_1.useAutoFocusEffect(props.autoFocus);
    var onToggle = props.disabled ? function () { } : props.onToggle;
    var backgroundColorClassName = props.selectedBackgroundColor === 'attention' ? "checkfield-attention-backgroundcolor" : null;
    return React.createElement(React.Fragment, null,
        React.createElement("span", null,
            React.createElement("div", { className: classNames("check-field react-check-field", props.className, backgroundColorClassName), title: props.title },
                React.createElement("input", { id: id, type: "checkbox", checked: props.value, disabled: props.disabled, onChange: onToggle, value: "true", ref: inputHtmlRef, title: props.title }),
                React.createElement("label", { disabled: props.disabled, onClick: onToggle }))));
}
exports.CheckboxField = CheckboxField;
